function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3398 10.332C17.836 10.332 18.2383 9.92979 18.2383 9.43359C18.2383 8.9374 17.836 8.53516 17.3398 8.53516C16.8437 8.53516 16.4414 8.9374 16.4414 9.43359C16.4414 9.92979 16.8437 10.332 17.3398 10.332Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4062 1.79688H18.2383V0.898438C18.2383 0.402231 17.8361 0 17.3398 0C16.8436 0 16.4414 0.402231 16.4414 0.898438V1.79688H12.3535V0.898438C12.3535 0.402231 11.9513 0 11.4551 0C10.9589 0 10.5566 0.402231 10.5566 0.898438V1.79688H6.51367V0.898438C6.51367 0.402231 6.11144 0 5.61523 0C5.11903 0 4.7168 0.402231 4.7168 0.898438V1.79688H3.59375C1.61216 1.79688 0 3.40903 0 5.39062V19.4062C0 21.3878 1.61216 23 3.59375 23H10.4668C10.963 23 11.3652 22.5978 11.3652 22.1016C11.3652 21.6054 10.963 21.2031 10.4668 21.2031H3.59375C2.60295 21.2031 1.79688 20.397 1.79688 19.4062V5.39062C1.79688 4.39983 2.60295 3.59375 3.59375 3.59375H4.7168V4.49219C4.7168 4.98839 5.11903 5.39062 5.61523 5.39062C6.11144 5.39062 6.51367 4.98839 6.51367 4.49219V3.59375H10.5566V4.49219C10.5566 4.98839 10.9589 5.39062 11.4551 5.39062C11.9513 5.39062 12.3535 4.98839 12.3535 4.49219V3.59375H16.4414V4.49219C16.4414 4.98839 16.8436 5.39062 17.3398 5.39062C17.8361 5.39062 18.2383 4.98839 18.2383 4.49219V3.59375H19.4062C20.397 3.59375 21.2031 4.39983 21.2031 5.39062V10.5117C21.2031 11.0079 21.6054 11.4102 22.1016 11.4102C22.5978 11.4102 23 11.0079 23 10.5117V5.39062C23 3.40903 21.3878 1.79688 19.4062 1.79688Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5645 12.1289C14.5673 12.1289 12.1289 14.5673 12.1289 17.5645C12.1289 20.5616 14.5673 23 17.5645 23C20.5616 23 23 20.5616 23 17.5645C23 14.5673 20.5616 12.1289 17.5645 12.1289ZM17.5645 21.2031C15.5581 21.2031 13.9258 19.5708 13.9258 17.5645C13.9258 15.5581 15.5581 13.9258 17.5645 13.9258C19.5708 13.9258 21.2031 15.5581 21.2031 17.5645C21.2031 19.5708 19.5708 21.2031 17.5645 21.2031Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8672 16.666H18.4629V15.7227C18.4629 15.2264 18.0607 14.8242 17.5645 14.8242C17.0682 14.8242 16.666 15.2264 16.666 15.7227V17.5645C16.666 18.0607 17.0682 18.4629 17.5645 18.4629H18.8672C19.3634 18.4629 19.7656 18.0607 19.7656 17.5645C19.7656 17.0682 19.3634 16.666 18.8672 16.666Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4316 10.332C13.9278 10.332 14.3301 9.92979 14.3301 9.43359C14.3301 8.9374 13.9278 8.53516 13.4316 8.53516C12.9354 8.53516 12.5332 8.9374 12.5332 9.43359C12.5332 9.92979 12.9354 10.332 13.4316 10.332Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.52344 14.2402C10.0196 14.2402 10.4219 13.838 10.4219 13.3418C10.4219 12.8456 10.0196 12.4434 9.52344 12.4434C9.02724 12.4434 8.625 12.8456 8.625 13.3418C8.625 13.838 9.02724 14.2402 9.52344 14.2402Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.61523 10.332C6.11143 10.332 6.51367 9.92979 6.51367 9.43359C6.51367 8.9374 6.11143 8.53516 5.61523 8.53516C5.11904 8.53516 4.7168 8.9374 4.7168 9.43359C4.7168 9.92979 5.11904 10.332 5.61523 10.332Z",
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M5.61523 14.2402C6.11143 14.2402 6.51367 13.838 6.51367 13.3418C6.51367 12.8456 6.11143 12.4434 5.61523 12.4434C5.11904 12.4434 4.7168 12.8456 4.7168 13.3418C4.7168 13.838 5.11904 14.2402 5.61523 14.2402Z",
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M5.61523 18.1484C6.11143 18.1484 6.51367 17.7462 6.51367 17.25C6.51367 16.7538 6.11143 16.3516 5.61523 16.3516C5.11904 16.3516 4.7168 16.7538 4.7168 17.25C4.7168 17.7462 5.11904 18.1484 5.61523 18.1484Z",
  fill: "currentColor"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M9.52344 18.1484C10.0196 18.1484 10.4219 17.7462 10.4219 17.25C10.4219 16.7538 10.0196 16.3516 9.52344 16.3516C9.02724 16.3516 8.625 16.7538 8.625 17.25C8.625 17.7462 9.02724 18.1484 9.52344 18.1484Z",
  fill: "currentColor"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M9.52344 10.332C10.0196 10.332 10.4219 9.92979 10.4219 9.43359C10.4219 8.9374 10.0196 8.53516 9.52344 8.53516C9.02724 8.53516 8.625 8.9374 8.625 9.43359C8.625 9.92979 9.02724 10.332 9.52344 10.332Z",
  fill: "currentColor"
});

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.67c3800e.svg";
export { ForwardRef as ReactComponent };